import {Component} from "../interface/component";

export class AccordionComponent implements Component {

    private $root:JQuery;
    private $items:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$items = this.$root.find('.js-accordion-trigger');
    }

    init() {
        if (this.$items.length > 1) {
            this.$items.next().hide();
            this.$items.on({click: this.clickHandler});
        }else{
            this.$items.attr('aria-expanded', 'true');
        }
    }

    clickHandler = (ev:Event) => {
        let element = $(ev.currentTarget);

        if (element.attr('aria-expanded') === 'true') {
            element.attr('aria-expanded', 'false');
            element.next().slideUp(200);
        } else {
            this.$items.attr('aria-expanded', 'false');
            this.$items.next().slideUp(200);
            element.attr('aria-expanded', 'true');
            element.next().slideDown(200);
        }
    }
}
